"use client";

import Image from "next/image";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type AuthSplitLayoutProps = {
  children: ReactNode;
  imageAlt?: string;
  className?: string;
  contentClassName?: string;
};

const AuthSplitLayout = ({
  children,
  imageAlt = "Fixrli illustration",
  className,
  contentClassName,
}: AuthSplitLayoutProps) => {
  return (
    <div
      className={cn(
        "font-sans min-h-screen grid grid-cols-1 lg:grid-cols-2 w-full",
        className,
      )}
    >
      <div
        className={cn(
          "max-lg:hidden lg:flex relative min-h-screen p-6 items-center order-2 lg:order-1",
        )}
      >
        <div
          className={cn(
            "relative w-full h-full min-h-[calc(100vh-3rem)] overflow-hidden rounded-xl bg-gray-100",
          )}
        >
          <Image
            src="/LogIn.png"
            alt={imageAlt}
            fill
            sizes="(min-width: 1024px) 50vw, 0px"
            className={cn("object-cover")}
            priority
          />
        </div>
      </div>

      <div
        className={cn(
          "flex flex-col items-center justify-center p-4 sm:p-6 md:p-8 lg:p-10 xl:p-12 bg-white overflow-auto order-1 lg:order-2 min-h-0",
          contentClassName,
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default AuthSplitLayout;
